import { render, staticRenderFns } from "./ReservationPaymentView.vue?vue&type=template&id=644ad27a&"
import script from "./ReservationPaymentView.vue?vue&type=script&lang=js&"
export * from "./ReservationPaymentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports